import { useState, useRef } from 'react'
import { Button } from '~/components/general/Button'
import { BLOCKS, TopLevelBlock } from '@contentful/rich-text-types'
import { RichText } from '~/components/RichText'

import type { RichTextOptions } from '~/components/RichText/types'
import { CopyIcon, InfoIcon } from '~/components/icons'
import { Document } from '@contentful/rich-text-types'
import { TypeCopyableBox } from '~/types/contentful'

type CopyableBoxProps = {
  copyableBox: TypeCopyableBox<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const CopyableBox = ({ copyableBox }: CopyableBoxProps) => {
  const { fields } = copyableBox
  const { title, body } = fields || {}
  const [clipboardButtonText, setClipboardButtonText] = useState('Copy to clipboard')
  const bodyElemRef = useRef(null)

  const richTextOptions: RichTextOptions = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => {
        return (
          <p className="text-xs" style={{ whiteSpace: 'pre-wrap', marginBottom: '1.5em' }}>
            {children}
          </p>
        )
      },
    },
  }

  const copyText = () => {
    if (!bodyElemRef.current) return
    const range = document.createRange()
    range.selectNode(bodyElemRef.current)
    window.getSelection()?.removeAllRanges()
    window.getSelection()?.addRange(range)
    document.execCommand('copy')
    window.getSelection()?.removeAllRanges()
    setClipboardButtonText('Text copied!')
    setTimeout(() => {
      setClipboardButtonText('Copy to clipboard')
    }, 1000)
  }

  return (
    <div className="mlb-12 max-xl:mlb-10 max-md:mlb-7 border-dashed rounded-3xl border-2 border-blue-30 pt-0 px-6 pb-3">
      <div className="flex gap-2 items-center border-b border-blue-20 h-16">
        <InfoIcon className="text-blue-50" />
        <div className="text-blue-50 text-mobile-s">{title as string}</div>
        <div className="flex-grow"></div>
        <div className="max-md:hidden">
          <Button
            text={clipboardButtonText}
            iconRight={<CopyIcon className="text-neutral-30" />}
            onClick={copyText}
            color={'transparent'}
            className={'!font-normal !text-mobile-s !border !border-neutral-15 hover:!bg-blue-10'}
          />
        </div>
      </div>
      <div className="pt-6 text-mobile-s" ref={bodyElemRef}>
        {(body as Document)?.content?.map((item: TopLevelBlock, index: number) => (
          <RichText
            key={`${item.nodeType}-${index}`}
            doc={item as unknown as Document}
            options={richTextOptions}
            className="DoDontTable__RichText"
          />
        ))}
      </div>
      <div className="hidden max-md:flex pt-4">
        <Button
          text={clipboardButtonText}
          iconRight={<CopyIcon className="text-neutral-30" />}
          onClick={copyText}
          color={'transparent'}
          className={'!font-normal !text-mobile-s !border !border-neutral-15 hover:!bg-blue-10'}
        />
      </div>
    </div>
  )
}
